import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from "@mui/material"
import Zoom from '@mui/material/Zoom';
import RtspPlayer from 'components/RtspPlayer';
import { getWebsocketHost, settingsConfig } from 'utils/commonFunc';
import { isSupported } from 'utils/mediasource-helper';

export const PopupViewEmer = ({ id, title, port }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)
    const [url, setUrl] = React.useState()

    React.useEffect(() => {
        setTransitionIn(true)
    }, [])

    React.useEffect(() => {
        if(id) {
            const serviceConfig = settingsConfig()
            setUrl(`${getWebsocketHost('/websocket/stream', port)}?id=${id}&width=${serviceConfig.cctvWidth}&height=${serviceConfig.cctvHeight}&fps=${serviceConfig.cctvFps}`)
        }
    }, [id])

    const TitleBox = styled(Box)(({ theme }) => ({
        position: 'absolute',
        top: 1,
        left: 1,
        fontSize: '16px',
        padding: theme.spacing(0.2, 3, 0.2, 1),
        background: 'linear-gradient(to bottom, rgb(60, 60, 60), rgb(20, 20, 20), rgb(20, 20, 20), rgb(60, 60, 60))',
        color: 'white',
        textAlign: 'center',
        clipPath: 'polygon(0% 0%, 100% 0%, calc(100% - 14px) 100%, 0% 100%)'
    }));
    const LiveBox = styled(Box)(({ theme }) => ({
        position: 'absolute',
        top: 1,
        right: 1,
        fontSize: '16px',
        padding: theme.spacing(0.5, 1),
        color: 'red',
        textAlign: 'right',
        animation: 'blink 2s infinite'
    }));

    return (
        <Zoom in={transitionIn} timeout={500} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <Box sx={{ border: 'solid rgb(60, 60, 60) 1px', p: 0.5, backgroundColor: 'rgb(30, 30, 30)' }}>
                <React.Fragment>
                    <TitleBox>{title}</TitleBox>
                    <LiveBox>{settingsConfig().viewTypeDisplay ? `MES Supported:${isSupported()} Settings:${settingsConfig().mseSupport}`: 'Live'}</LiveBox>
                </React.Fragment>
                <Box sx={{ width: settingsConfig().cctvWidth, height: settingsConfig().cctvHeight }}>
                    <RtspPlayer url={url} fps={settingsConfig().cctvFps}/>
                </Box>
            </Box>
        </Zoom>
    )
}